const positionFill = {
  position: 'absolute',
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
};

export const getTilesGridCellImageStyles = () => ({
  tilesGridCellImageContainer: {
    '& .cell-image-state': {
      ...positionFill,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  imageStateOverlayClass: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
  },
  stateParent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
  reloadBtn: {
    zIndex: 1,
  },
});
